const NEWSLETTER_EMAIL_PLACEHOLDER = "E-Mail-Adreasse*";

const NEWSLETTER_EMAIL_SELECTOR = [
    '#et_pb_signup_email',
    '.et_pb_newsletter_form input[type="email"]',
    '.et_pb_newsletter_form input[name="email"]',
    '.et_pb_newsletter input[type="email"]',
    '.et_pb_newsletter input[name="email"]',
    '.et_pb_subscribe input[type="email"]',
    '.et_pb_subscribe input[name="email"]',
].join(',');

function updateNewsletterEmailPlaceholder() {
    document.querySelectorAll(NEWSLETTER_EMAIL_SELECTOR).forEach((field) => {
        field.setAttribute("placeholder", NEWSLETTER_EMAIL_PLACEHOLDER);
    });
}

document.addEventListener("DOMContentLoaded", updateNewsletterEmailPlaceholder);
window.addEventListener("load", updateNewsletterEmailPlaceholder);
window.setTimeout(updateNewsletterEmailPlaceholder, 250);
window.setTimeout(updateNewsletterEmailPlaceholder, 1000);

if ("MutationObserver" in window) {
    new MutationObserver(updateNewsletterEmailPlaceholder)
        .observe(document.documentElement, { childList: true, subtree: true });
}
